import { TitleMoreArrow, TitleMoreText, Wrapper } from './Styled'

interface ButtonSearchMoreProps {
  handleClick?: () => void
  text?: string
  [key: string]: any
}

export default function ButtonSearchMore({ handleClick, text = '更多', ...props }: ButtonSearchMoreProps) {
  return (
    <Wrapper onClick={handleClick} {...props}>
      <TitleMoreText>{text}</TitleMoreText>
      <TitleMoreArrow></TitleMoreArrow>
    </Wrapper>
  )
}
